/**
 * 요청 추적 ID. 매 요청 새로 만들어 헤더로 보내고, 서버가 로그(MDC reqId)와 응답 헤더에 같은 값을 쓴다.
 * 백엔드 sanitize 규칙에 맞춰 [A-Za-z0-9_-] 64자 이내만 허용된다(어기면 서버가 버리고 자체 생성).
 */
export const REQUEST_ID_HEADER = 'X-Insait-Request-Id';

export function newRequestId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  // randomUUID 는 보안 컨텍스트(https·localhost)에서만 제공 - 사내 http 주소 접속 대비 폴백.
  return `r-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

/** 응답(또는 오류)에서 서버가 되돌려 준 요청 ID. axios 응답 헤더 키는 소문자. */
export function requestIdOf(errOrResponse) {
  const headers = errOrResponse?.response?.headers ?? errOrResponse?.headers;
  return headers?.[REQUEST_ID_HEADER.toLowerCase()] || '';
}
